// 简体中文语言包
export default {
  '页面标题': '东风奕派',
  '加载中...': '加载中...',
  '车型': '车型',
  '技术': '技术',
  '零售中心': '零售中心',
  '服务中心': '服务中心',
  '关于我们': '关于我们',
  '其他工具': '其他工具',
  '预订': '预订',
  '预约试驾': '预约试驾',
  '请登录': '请登录',
  '关闭菜单': '关闭菜单',
  '菜单': '菜单',
  '关闭': '关闭',
  '邮箱登录': '邮箱登录',
  '手机号登录': '手机号登录',
  '请输入邮箱': '请输入邮箱',
  '请输入手机号': '请输入手机号',
  '请输入密码(6~12位字母+数字)': '请输入密码(6~12位字母+数字)',
  '登录': '登录',
  '注册账号': '注册账号',
  '忘记密码': '忘记密码',
  '其他登录方式': '其他登录方式',
  '我已阅读并同意': '我已阅读并同意',
  '与': '与',
  '《用户注册协议》': '《用户注册协议》',
  '《隐私政策》': '《隐私政策》',
  '微信二维码': '微信二维码',
  '东风自研': '东风自研',
  '革新技术': '革新技术',
  '东风快讯': '东风快讯',
  '联系我们': '联系我们',
  '车型参数对比': '车型参数对比',
  '个人中心': '个人中心',
  '个人信息': '个人信息',
  '我的预订': '我的预订',
  '我的预约试驾': '我的预约试驾',
  '退出登录': '退出登录',
  '简体中文': '简体中文',
  '繁體中文': '繁體中文',
  'English': 'English',
  '语言': '语言',
  '邮箱': '邮箱',
  '手机号': '手机号',
  '密码': '密码',
  '请输入密码': '请输入密码',
  '用户协议': '用户协议',
  '和': '和',
  '隐私条款': '隐私条款',
  '请输入手机号码': '请输入手机号码',
  '登录密码': '登录密码',
  '验证码登录': '验证码登录',
  '验证码': '验证码',
  '请输入验证码': '请输入验证码',
  '密码登录': '密码登录',
  '注册登录即同意': '注册登录即同意',
  '验证码请求失败，请重试': '验证码请求失败，请重试',
  '请阅读并同意遵守《用户协议》': '请阅读并同意遵守《用户协议》',
  '手机号不能为空': '手机号不能为空',
  '邮箱不能为空': '邮箱不能为空',
  '邮箱错误': '邮箱错误',
  '密码不能为空': '密码不能为空',
  '密码必须为6~12位字母加数字的组合': '密码必须为6~12位字母加数字的组合',
  '登录信息异常，请重试': '登录信息异常，请重试',
  '获取用户信息失败': '获取用户信息失败',
  '登录成功': '登录成功',
  '登录失败': '登录失败',
  '登录失败，请稍后重试': '登录失败，请稍后重试',
  '获取验证码': '获取验证码',
  '{count}s后重新获取': '{count}s后重新获取',
  '注册': '注册',
  '使用手机号注册': '使用手机号注册',
  '使用邮箱注册': '使用邮箱注册',
  '已有账号，前去登录': '已有账号，前去登录',
  '请输入正确的邮箱格式': '请输入正确的邮箱格式',
  '注册成功，去登录': '注册成功，去登录',
  '注册失败': '注册失败',
  '请输入新密码(6~12位字母+数字)': '请输入新密码(6~12位字母+数字)',
  '确定': '确定',
  '使用手机号找回': '使用手机号找回',
  '使用邮箱找回': '使用邮箱找回',
  '返回': '返回',
  '新密码': '新密码',
  '验证码不能为空': '验证码不能为空',
  '修改成功，去登录': '修改成功，去登录',
  '修改失败': '修改失败',
  '售价': '售价',
  '万元': '万元',
  '万元起': '万元起',
  '详情': '详情',
  '查看详情': '查看详情',
  '了解更多': '了解更多',
  '上一张': '上一张',
  '下一张': '下一张',
  '切换到第{count}张': '切换到第{count}张',
  '观看完整视频': '观看完整视频',
  '关闭视频': '关闭视频',
  '品牌故事完整视频': '品牌故事完整视频',
  '东风家族 匠心之作': '东风家族 匠心之作',
  '以科技与美学重新定义出行体验': '以科技与美学重新定义出行体验',
  '品牌故事': '品牌故事',
  '见证东风与时代同行的每一步': '见证东风与时代同行的每一步',
  '探索东风科技': '探索东风科技',
  '智能 · 电动 · 安全，驱动未来出行': '智能 · 电动 · 安全，驱动未来出行',
  '感受东风服务': '感受东风服务',
  '全程陪伴，让每一程更安心': '全程陪伴，让每一程更安心',
  '关怀、品质、智慧、平台': '关怀、品质、智慧、平台',
  '立即预定': '立即预定',
  '播放视频': '播放视频',
  '观看视频': '观看视频',
  '上一张外观图': '上一张外观图',
  '下一张外观图': '下一张外观图',
  '切换到第{count}张外观图': '切换到第{count}张外观图',
  '上一张内饰图': '上一张内饰图',
  '下一张内饰图': '下一张内饰图',
  '切换到第{count}张内饰图': '切换到第{count}张内饰图',
  '上一页': '上一页',
  '下一页': '下一页',
  '第{count}页': '第{count}页',
  '更多功能与场景': '更多功能与场景',
  '车型详情加载失败，请稍后重试': '车型详情加载失败，请稍后重试',
  '车型选择': '车型选择',
  '请选择': '请选择',
  '全国统一零售价': '全国统一零售价',
  '基础参数': '基础参数',
  '长度': '长度',
  '宽度': '宽度',
  '高度': '高度',
  '轴距': '轴距',
  '座位数': '座位数',
  '座位布局': '座位布局',
  'CLTC综合工况续航里程': 'CLTC综合工况续航里程',
  '5C超充时间': '5C超充时间',
  '风阻系数': '风阻系数',
  '电动系统': '电动系统',
  '高压纯电平台': '高压纯电平台',
  '动力电池类型': '动力电池类型',
  '动力电池总电量': '动力电池总电量',
  'CLTC综合工况能耗': 'CLTC综合工况能耗',
  '5C超充功率': '5C超充功率',
  '外观与内饰': '外观与内饰',
  '车漆颜色': '车漆颜色',
  '增程电动平台': '增程电动平台',
  '增程器': '增程器',
  '增程器长周期保养': '增程器长周期保养',
  'CLTC纯电续航里程': 'CLTC纯电续航里程',
  'WLTC纯电续航里程': 'WLTC纯电续航里程',
  '已包含': '已包含',
  '已购': '已购',
  '选购': '选购',
  '外观内饰': '外观内饰',
  '选装配置': '选装配置',
  '外观': '外观',
  '外观套件': '外观套件',
  '轮毂': '轮毂',
  '内饰': '内饰',
  '此时下单，预计10-12周内交付': '此时下单，预计10-12周内交付',
  '选装': '选装',
  '确定预定': '确定预定',
  '明细清单': '明细清单',
  '购车总价': '购车总价',
  '继续选配': '继续选配',
  '请填写您的预订信息': '请填写您的预订信息',
  '购车类型': '购车类型',
  '购车方案': '购车方案',
  '姓名': '姓名',
  '请输入': '请输入',
  '证件类型': '证件类型',
  '证件号码': '证件号码',
  '取车门店': '取车门店',
  '国家': '国家',
  '省份': '省份',
  '选择门店': '选择门店',
  '预订须知': '预订须知',
  '明细': '明细',
  '个人': '个人',
  '企业': '企业',
  '居民身份证': '居民身份证',
  '护照': '护照',
  '全款': '全款',
  '金融分期': '金融分期',
  '取消': '取消',
  '请选择国家': '请选择国家',
  '请选择省份': '请选择省份',
  '请选择门店': '请选择门店',
  '预订成功!': '预订成功!',
  '已将您的预订需求发送至门店，请留意官方人员来电': '已将您的预订需求发送至门店，请留意官方人员来电',
  '查看订单': '查看订单',
  '地区列表加载失败，请稍后重试': '地区列表加载失败，请稍后重试',
  '门店列表加载失败，请稍后重试': '门店列表加载失败，请稍后重试',
  '请输入姓名': '请输入姓名',
  '请输入证件号码': '请输入证件号码',
  '请选择取车门店': '请选择取车门店',
  '车型信息缺失，请返回重新选择车型': '车型信息缺失，请返回重新选择车型',
  '选配信息缺失，请返回重新选择配置': '选配信息缺失，请返回重新选择配置',
  '预订提交失败，请重试': '预订提交失败，请重试',
  '奕派智能空间': '奕派智能空间',
  '智能黄金标准': '智能黄金标准',
  '智能满配体验': '智能满配体验',
  '真好用， 安全、 便捷又易用': '真好用， 安全、 便捷又易用',
  '原生智能，定义座舱新标杆': '原生智能，定义座舱新标杆',
  '此处是一则标题': '此处是一则标题',
  '标题配置': '标题配置',
  '搭载无瑕星环剧院音响系统，29个座舱扬声器、4个头枕扬声器，峰值总功率5440W，9.3.6双全景声环绕，声声悦耳。': '搭载无瑕星环剧院音响系统，29个座舱扬声器、4个头枕扬声器，峰值总功率5440W，9.3.6双全景声环绕，声声悦耳。',
  '27个智能感知硬件，1个舱内激光视觉Limera，3个4D毫米波雷达，11个高精摄像头，12个超声波雷达': '27个智能感知硬件，1个舱内激光视觉Limera，3个4D毫米波雷达，11个高精摄像头，12个超声波雷达',
  '多模态感知': '多模态感知',
  '多模态感知与生成一体化模型，能通过视觉、语音、文字等多种方式认识世界，还能结合所在地点、时间，随时随地陪伴全家人。': '多模态感知与生成一体化模型，能通过视觉、语音、文字等多种方式认识世界，还能结合所在地点、时间，随时随地陪伴全家人。',
  '灵活规划': '灵活规划',
  '能根据语音、文本等信息，进行多模态融合规划。有强大的理解能力，可以对复杂任务进行拆解，分步调用工具，像人脑一样思考。': '能根据语音、文本等信息，进行多模态融合规划。有强大的理解能力，可以对复杂任务进行拆解，分步调用工具，像人脑一样思考。',
  '自主行动': '自主行动',
  '处理复杂任务反应迅速、执行准确，与应用深度融合，能调用丰富内外部工具，表达自然拟人、有逻辑，遇到问题，放心交给它。': '处理复杂任务反应迅速、执行准确，与应用深度融合，能调用丰富内外部工具，表达自然拟人、有逻辑，遇到问题，放心交给它。',
  '拟人对话': '拟人对话',
  '升级MindGPT-4o-preview端到端语音模型能力，有更丰富的音色，更类人的情绪表达，更有趣的聊天风格，还能更好的读懂你的心情。': '升级MindGPT-4o-preview端到端语音模型能力，有更丰富的音色，更类人的情绪表达，更有趣的聊天风格，还能更好的读懂你的心情。',
  '双门双向智能冷暖箱': '双门双向智能冷暖箱',
  '-6°C~50°C宽温域|8.8L大容积': '-6°C~50°C宽温域|8.8L大容积',
  '双视界大屏幕': '双视界大屏幕',
  '16.1英寸3K华为中控屏   17.3英寸3K后排吸顶屏': '16.1英寸3K华为中控屏   17.3英寸3K后排吸顶屏',
  '同级最大50英寸AR-HUD': '同级最大50英寸AR-HUD',
  '实景路况指引，从容出行': '实景路况指引，从容出行',
  '全置换新风': '全置换新风',
  '诺贝尔奖级MOFs尖端滤芯': '诺贝尔奖级MOFs尖端滤芯',
  '该技术详情暂未配置': '该技术详情暂未配置',
  '你好，我们是东风汽车': '你好，我们是东风汽车',
  '聚焦主流新能源市场为客户创造无限不循环的未来出行可能': '聚焦主流新能源市场为客户创造无限不循环的未来出行可能',
  '东风奕派，智慧科技电动品牌': '东风奕派，智慧科技电动品牌',
  '奕派科技承袭东风汽车企业使命': '奕派科技承袭东风汽车企业使命',
  '让汽车驱动梦想': '让汽车驱动梦想',
  '东风坚信，汽车始终是工业领域先进科技的集大成者，不仅仅是移动的工具已经成为家庭和工作之外的第三空间，拥有无限创新发展可能': '东风坚信，汽车始终是工业领域先进科技的集大成者，不仅仅是移动的工具已经成为家庭和工作之外的第三空间，拥有无限创新发展可能',
  '技术东风 科技随行 愉悦交互': '技术东风 科技随行 愉悦交互',
  '天元智驾': '天元智驾',
  '天元智舱': '天元智舱',
  '信赖基石 品质无忧': '信赖基石 品质无忧',
  '量子架构 核心技术坚持自研': '量子架构 核心技术坚持自研',
  '天元T100': '天元T100',
  '实现L2级高速NOA、记忆领航辅助驾驶和跨层记忆泊车': '实现L2级高速NOA、记忆领航辅助驾驶和跨层记忆泊车',
  '便捷': '便捷',
  '贴心': '贴心',
  '更懂你': '更懂你',
  '满足全家人的需求交互更流畅': '满足全家人的需求交互更流畅',
  '多维拓展': '多维拓展',
  '低碳高效': '低碳高效',
  '极致性能': '极致性能',
  '匠心品质': '匠心品质',
  '风阻系数低至0.21低温续航衰减低至30%': '风阻系数低至0.21低温续航衰减低至30%',
  '发布于': '发布于',
  '分页': '分页',
  '新闻列表加载失败，请稍后重试': '新闻列表加载失败，请稍后重试',
  '文章导航': '文章导航',
  '上一篇': '上一篇',
  '下一篇': '下一篇',
  '列表': '列表',
  '返回列表': '返回列表',
  '未找到该快讯': '未找到该快讯',
  '新闻详情加载失败，请稍后重试': '新闻详情加载失败，请稍后重试',
  '暂无': '暂无',
  '试驾体验，不止于驾驶。': '试驾体验，不止于驾驶。', '试驾车辆': '试驾车辆', '试驾门店': '试驾门店', '试驾人': '试驾人', '先生': '先生', '女士': '女士', '立即预约': '立即预约', '确定预约': '确定预约', '选择车辆': '选择车辆', '离您较近的门店': '离您较近的门店', '查看全部门店': '查看全部门店', '试驾车': '试驾车', '展车': '展车', '暂无服务内容': '暂无服务内容', '预约试驾成功': '预约试驾成功', '预约试驾成功!': '预约试驾成功!', '已将您的预约试驾申请发送至门店，请留意官方人员来电': '已将您的预约试驾申请发送至门店，请留意官方人员来电', '知道了': '知道了', '验证码发送失败，请重试': '验证码发送失败，请重试', '验证码已发送': '验证码已发送', '请选择试驾车辆': '请选择试驾车辆', '请选择试驾门店': '请选择试驾门店', '请输入试驾人姓名': '请输入试驾人姓名', '预约提交失败，请重试': '预约提交失败，请重试',
  '寻找离您最近的东风奕派门店': '寻找离您最近的东风奕派门店',
  '请选择省': '请选择省',
  '请选择市': '请选择市',
  '选择所在地区': '选择所在地区',
  '请选择省/市/区': '请选择省/市/区',
  '当前位置': '当前位置',
  '确认': '确认',
  '我们友好且敬业的团队已准备好随时协助您解决任何需求并全程陪伴您左右！现在就联系我们吧。': '我们友好且敬业的团队已准备好随时协助您解决任何需求并全程陪伴您左右！现在就联系我们吧。',
  '暂无门店信息': '暂无门店信息',
  '头像': '头像',
  '上传中': '上传中',
  '修改头像': '修改头像',
  '确定退出当前账号吗？': '确定退出当前账号吗？',
  '姓名不能为空': '姓名不能为空',
  '姓名修改失败': '姓名修改失败',
  '姓名修改成功': '姓名修改成功',
  '姓名修改失败，请稍后重试': '姓名修改失败，请稍后重试',
  '请选择图片文件': '请选择图片文件',
  '头像上传失败': '头像上传失败',
  '头像修改失败': '头像修改失败',
  '头像修改成功': '头像修改成功',
  '头像修改失败，请稍后重试': '头像修改失败，请稍后重试',
  '预订人：': '预订人：',
  '预订时间：': '预订时间：',
  '预订门店：': '预订门店：',
  '暂无预订记录': '暂无预订记录',
  '预订列表加载失败，请稍后重试': '预订列表加载失败，请稍后重试',
  '试驾人：': '试驾人：',
  '试驾门店：': '试驾门店：',
  '试驾时间：': '试驾时间：',
  '暂无预约，去预约试驾喜欢的汽车吧~': '暂无预约，去预约试驾喜欢的汽车吧~',
  '去预约': '去预约',
  '待门店确认试驾时间': '待门店确认试驾时间',
  '预约试驾列表加载失败，请稍后重试': '预约试驾列表加载失败，请稍后重试',
  '我的预订详情': '我的预订详情',
  '方案': '方案',
  '预订详情数据异常': '预订详情数据异常',
  '预订详情加载失败，请稍后重试': '预订详情加载失败，请稍后重试',
  '查看课程': '查看课程', '城市地区': '城市地区', '倒计时结束后再发送': '倒计时结束后再发送', '购买': '购买', '购物车': '购物车', '回到顶部': '回到顶部', '客服电话：{phone}': '客服电话：{phone}', '客服暂时无法连接，请稍后再试': '客服暂时无法连接，请稍后再试', '快捷操作': '快捷操作', '联系客服': '联系客服', '请输入护照姓名(英文)': '请输入护照姓名(英文)', '请输入使用者姓名(请填写实名)': '请输入使用者姓名(请填写实名)', '请选择您的生日': '请选择您的生日', '我的收藏': '我的收藏', '移除': '移除', '隐私政策': '隐私政策', '重新获取': '重新获取',
  '请输入使用者姓名': '请输入使用者姓名', '请选择地区': '请选择地区',
  '请选择所在地区': '请选择所在地区',
  '金融试算器': '金融试算器',
  '车辆类型': '车辆类型',
  '选择车型': '选择车型',
  '购车价格': '购车价格',
  '金融方案': '金融方案',
  '贷款城市': '贷款城市',
  '贷款城市请选择您车辆的上牌城市': '贷款城市请选择您车辆的上牌城市',
  '暂无适用金融产品': '暂无适用金融产品',
  '首付比例': '首付比例',
  '分期期数': '分期期数',
  '金融试算明细': '金融试算明细',
  '预估首付': '预估首付',
  '贷款/融资金额': '贷款/融资金额',
  '金融产品': '金融产品',
  '{count}期': '{count}期',
  '预估月付': '预估月付',
  '利息': '利息',
  '年化费率': '年化费率',
  '近似年化利率{rate}%': '近似年化利率{rate}%',
  '请选择车型': '请选择车型',
  '暂无金融产品': '暂无金融产品',
  '未命名金融产品': '未命名金融产品',
  '金融机构': '金融机构',
  '东风服务': '东风服务',
  '服务指南': '服务指南',
  '超长质保': '超长质保',
  '整车5年或10万公里，三电8年或16万公里': '整车5年或10万公里，三电8年或16万公里',
  '售后服务网络': '售后服务网络',
  '覆盖200+城市，身边就有的服务中心。': '覆盖200+城市，身边就有的服务中心。',
  '道路救援': '道路救援',
  '整车质保期内，因车辆质量问题无法正常行驶时，<br>为您提供7*24小时便捷安心的救援服务。': '整车质保期内，因车辆质量问题无法正常行驶时，<br>为您提供7*24小时便捷安心的救援服务。',
  '尊享服务': '尊享服务',
  '理想整车延长保修服务，最高保障至8年或16万公里。<br>理想用车服务包，一包涵盖核心养车需求。': '理想整车延长保修服务，最高保障至8年或16万公里。<br>理想用车服务包，一包涵盖核心养车需求。',
  '专业线上服务': '专业线上服务',
  '官方客服、理想汽车App、电话等多渠道快速响应。': '官方客服、理想汽车App、电话等多渠道快速响应。',
  '流量无忧': '流量无忧',
  'OTA升级、车机导航等基础功能终身免流量。<br>赠送36个月、每月20GB娱乐流量。': 'OTA升级、车机导航等基础功能终身免流量。<br>赠送36个月、每月20GB娱乐流量。',
  '智能用车助手': '智能用车助手',
  '像和真人客服对话一样自然。咨询用车问题、查询车辆状态、诊断故障灯，理想同学都能理解，并给出图文或视频解答，解决每个人的用车疑惑。': '像和真人客服对话一样自然。咨询用车问题、查询车辆状态、诊断故障灯，理想同学都能理解，并给出图文或视频解答，解决每个人的用车疑惑。',
  '一站式技术支持与服务': '一站式技术支持与服务',
  '多渠道在线，快速响应，及时解决您的用车问题。': '多渠道在线，快速响应，及时解决您的用车问题。',
  '专业维修服务中心': '专业维修服务中心',
  '专家全程一对一服务，配合覆盖全国的取送车服务，有保障，也更靠谱。': '专家全程一对一服务，配合覆盖全国的取送车服务，有保障，也更靠谱。',
  '我的预定': '我的预定',
  '零售与服务': '零售与服务',
  'Middle East Network': 'Middle East Network',
  '全新奕跑SHINE': '全新奕跑SHINE'
};
